import { graphQuery, graphMutation } from './commService';

export const fetchParagraphs = async () => {
  const query = `
    query {
      textStimuli(type: FREE_TEXT) {
        id
        type
        locale
        text
        wordCount
        population
        createdAt
        updatedAt
      }
    }
  `;
  const res = await graphQuery(query, true);
  return res?.data?.textStimuli || [];
};

export const bulkCreateParagraphs = async (inputs) => {
  const sanitizedInputs = (inputs || []).map((i) => ({
    text: i?.text,
    locale: i?.locale,
    population: i?.population,
  }));
  const mutation = `
    mutation($inputs: [ParagraphStimulusInput!]!) {
      bulkCreateParagraphStimuli(inputs: $inputs) {
        id
        type
        locale
        text
        wordCount
        population
        createdAt
        updatedAt
      }
    }
  `;
  const res = await graphMutation(mutation, { inputs: sanitizedInputs }, true);
  return res?.data?.bulkCreateParagraphStimuli || [];
};

export const deleteParagraph = async (id) => {
  const mutation = `
    mutation($id: String!) {
      deleteParagraphStimulus(id: $id)
    }
  `;
  const res = await graphMutation(mutation, { id }, true);
  return res?.data?.deleteParagraphStimulus;
};

export const updateParagraph = async (id, input) => {
  const sanitizedInput = {
    text: String(input?.text ?? '').trim(),
    locale: input?.locale,
    population: Array.isArray(input?.population) ? input.population : [],
  };

  const mutation = `
    mutation($id: String!, $input: UpdateParagraphStimulusInput!) {
      updateParagraphStimulus(id: $id, input: $input) {
        id
        type
        locale
        text
        wordCount
        population
        createdAt
        updatedAt
      }
    }
  `;

  const res = await graphMutation(mutation, { id, input: sanitizedInput }, true);
  return res?.data?.updateParagraphStimulus || null;
};
